import { useAuthStore } from '@/store/auth'
import axios from 'axios'
import merge from 'lodash/merge'
import { requestAuthorizationHeader, shouldExpireSession } from '~/utils/session'

const service = axios.create({
  baseURL: import.meta.env?.VITE_API_BASE || 'http://localhost/api',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

service.interceptors.request.use(
  (config) =>
    merge({}, config, {
      headers: {
        Authorization: useAuthStore().isAuthenticated ? useAuthStore().authorizationHeader : undefined,
      },
    }),
  (error) => Promise.reject(error),
)

service.interceptors.response.use(
  (response) => (response.data?.meta ? response.data : response?.data?.data ?? response.data),
  (error) => {
    // Only the session whose token the failed request carried is expired: parallel 403s
    // find it already cleared, and a delayed 403 from a previous session leaves a newer one alone.
    const authStore = useAuthStore()

    if (shouldExpireSession(error, authStore)) {
      // Recording the route runs outside component setup, so useCookie() and useRoute() need
      // Nuxt's client app instance. Where a 403 lands without one (a plugin-time request), the
      // route is not recorded, the session is still expired, and the error still reaches its
      // caller with its response.
      try {
        useCookie('intendedRoute').value = useRoute().fullPath
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to record the intended route:', err)
      }

      authStore.expireSession(requestAuthorizationHeader(error)).catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Failed to expire the session:', err)
      })
    }

    return Promise.reject(error)
  },
)

export default service
